import script from "./FiltersStudentPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltersStudentPanel.vue?vue&type=script&setup=true&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import "./FiltersStudentPanel.vue?vue&type=style&index=1&id=a665cd96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a665cd96"]])

export default __exports__